import React, { useState, useEffect, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { getFirestore, doc, getDoc, collection, addDoc, query, where, getDocs, orderBy, serverTimestamp, updateDoc, onSnapshot } from 'firebase/firestore';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCf55RI3eVP7Qv3Wlf1dL58JlWt2qAaUN8",
  authDomain: "qar-app-f235f.firebaseapp.com",
  projectId: "qar-app-f235f",
  storageBucket: "qar-app-f235f.firebasestorage.app",
  messagingSenderId: "144465029716",
  appId: "1:144465029716:web:167cb5f2878895ddee5bc1"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const VAPID_KEY = 'BKZrpSdhPVsM1PopQYgcH89YfA2Yg9HUO1TPAlSVzz8FE1ltKmnFP3ztfom2wo2wyEStg40GhwUaqoQcPqICgao';
const GOOGLE_MAPS_API_KEY = 'AIzaSyBAm5hl1jLiJFHWsD0OhoWT8HWUGhr9zsw';
let messaging = null;

// ============================================
// QAR DESIGN SYSTEM
// ============================================
const QAR_COLORS = {
  bgPrimary: '#0B0F1A',
  bgCard: '#151A27',
  bgCardHover: '#1A2030',
  accent: '#FED631',
  accentSecondary: '#FFFFFF',
  accentDim: 'rgba(254, 214, 49, 0.15)',
  accentGlow: 'rgba(254, 214, 49, 0.3)',
  danger: '#FF4D6A',
  warning: '#FFB84D',
  textPrimary: '#FFFFFF',
  textSecondary: '#8A8FA8',
  textMuted: '#4A4F63',
  border: '#252A3A',
  cardRadius: '22px',
  buttonRadius: '14px',
};

// ============================================
// TRANSLATIONS
// ============================================
const TRANSLATIONS = {
  ru: {
    // Header
    logout: 'Выйти',
    
    // Alert Types
    blocking: 'Блокирует',
    parking: 'Парковка',
    lights_on: 'Освещение',
    open: 'Открыто',
    alarm: 'Спецслужбы',
    tow: 'Эвакуатор',
    
    // Public Alert Page
    selectProblem: 'Выберите проблему',
    carBlocks: 'Этот автомобиль:',
    send: 'Отправить',
    sending: 'Отправка...',
    messageSent: 'Сообщение отправлено!',
    ownerNotified: 'Владелец получит уведомление',
    wait: 'Подождите',
    beforeNextMessage: 'до следующего сообщения',
    
    // Login
    login: 'Вход',
    email: 'Email',
    password: 'Пароль',
    enter: 'Войти',
    noAccount: 'Нет аккаунта?',
    orderSticker: 'Закажите стикер',
    
    // Registration
    activation: 'Активация QR',
    carBrand: 'Марка авто',
    carModel: 'Модель',
    carPlate: 'Гос. номер',
    phone: 'Телефон',
    activateQR: 'Активировать QR',
    
    // Dashboard
    myCars: 'Мои авто',
    noCars: 'Нет добавленных авто',
    scanQR: 'Отсканируйте QR-стикер для активации',
    
    // Bottom Nav
    home: 'Главная',
    history: 'История',
    services: 'Сервисы',
    settings: 'Настройки',
    
    // History
    alertHistory: 'История уведомлений',
    noAlerts: 'Нет уведомлений',
    justNow: 'Только что',
    minAgo: 'мин назад',
    hAgo: 'ч назад',
    
    // Services
    servicesTitle: 'Сервисы',
    nearestServices: 'Ближайшие сервисы',
    partner: 'Партнёр QAR',
    
    // Settings
    settingsTitle: 'Настройки',
    pushNotifications: 'Push-уведомления',
    language: 'Язык',
    
    // Status
    active: 'Активен',
    pending: 'Ожидание',
    resolved: 'Решено',
    
    // Errors
    qrNotFound: 'QR не найден',
    error: 'Ошибка',
  },
  
  en: {
    // Header
    logout: 'Logout',
    
    // Alert Types
    blocking: 'Blocking',
    parking: 'Parking',
    lights_on: 'Lights on',
    open: 'Open',
    alarm: 'Emergency',
    tow: 'Tow truck',
    
    // Public Alert Page
    selectProblem: 'Select problem',
    carBlocks: 'This car:',
    send: 'Send',
    sending: 'Sending...',
    messageSent: 'Message sent!',
    ownerNotified: 'Owner will be notified',
    wait: 'Wait',
    beforeNextMessage: 'before next message',
    
    // Login
    login: 'Login',
    email: 'Email',
    password: 'Password',
    enter: 'Sign in',
    noAccount: 'No account?',
    orderSticker: 'Order sticker',
    
    // Registration
    activation: 'QR Activation',
    carBrand: 'Car brand',
    carModel: 'Model',
    carPlate: 'License plate',
    phone: 'Phone',
    activateQR: 'Activate QR',
    
    // Dashboard
    myCars: 'My cars',
    noCars: 'No cars added',
    scanQR: 'Scan QR sticker to activate',
    
    // Bottom Nav
    home: 'Home',
    history: 'History',
    services: 'Services',
    settings: 'Settings',
    
    // History
    alertHistory: 'Notification history',
    noAlerts: 'No notifications',
    justNow: 'Just now',
    minAgo: 'min ago',
    hAgo: 'h ago',
    
    // Services
    servicesTitle: 'Services',
    nearestServices: 'Nearest services',
    partner: 'QAR Partner',
    
    // Settings
    settingsTitle: 'Settings',
    pushNotifications: 'Push notifications',
    language: 'Language',
    
    // Status
    active: 'Active',
    pending: 'Pending',
    resolved: 'Resolved',
    
    // Errors
    qrNotFound: 'QR not found',
    error: 'Error',
  },
  
  ro: {
    // Header
    logout: 'Ieșire',
    
    // Alert Types
    blocking: 'Blochează',
    parking: 'Parcare',
    lights_on: 'Luminile',
    open: 'Deschis',
    alarm: 'Urgență',
    tow: 'Evacuator',
    
    // Public Alert Page
    selectProblem: 'Selectați problema',
    carBlocks: 'Această mașină:',
    send: 'Trimite',
    sending: 'Se trimite...',
    messageSent: 'Mesaj trimis!',
    ownerNotified: 'Proprietarul va fi notificat',
    wait: 'Așteptați',
    beforeNextMessage: 'până la următorul mesaj',
    
    // Login
    login: 'Autentificare',
    email: 'Email',
    password: 'Parolă',
    enter: 'Intră',
    noAccount: 'Nu aveți cont?',
    orderSticker: 'Comandați autocolant',
    
    // Registration
    activation: 'Activare QR',
    carBrand: 'Marca mașinii',
    carModel: 'Model',
    carPlate: 'Număr de înmatriculare',
    phone: 'Telefon',
    activateQR: 'Activează QR',
    
    // Dashboard
    myCars: 'Mașinile mele',
    noCars: 'Nu sunt mașini adăugate',
    scanQR: 'Scanați autocolantul QR pentru activare',
    
    // Bottom Nav
    home: 'Acasă',
    history: 'Istoric',
    services: 'Servicii',
    settings: 'Setări',
    
    // History
    alertHistory: 'Istoricul notificărilor',
    noAlerts: 'Nu sunt notificări',
    justNow: 'Chiar acum',
    minAgo: 'min în urmă',
    hAgo: 'h în urmă',
    
    // Services
    servicesTitle: 'Servicii',
    nearestServices: 'Servicii din apropiere',
    partner: 'Partener QAR',
    
    // Settings
    settingsTitle: 'Setări',
    pushNotifications: 'Notificări push',
    language: 'Limbă',
    
    // Status
    active: 'Activ',
    pending: 'În așteptare',
    resolved: 'Rezolvat',
    
    // Errors
    qrNotFound: 'QR nu a fost găsit',
    error: 'Eroare',
  }
};

// Language detection
const getBrowserLanguage = () => {
  const lang = navigator.language?.slice(0, 2) || 'ru';
  if (['ru', 'en', 'ro'].includes(lang)) return lang;
  return 'ru';
};

const getStoredLanguage = () => localStorage.getItem('qar_lang') || getBrowserLanguage();
const setStoredLanguage = (lang) => localStorage.setItem('qar_lang', lang);

// ============================================
// SVG ICONS
// ============================================
const Icons = {
  blocked: (
    <svg width="48" height="28" viewBox="0 0 281 164" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M73.4072 0C60.6806 8.95115e-05 48.8473 6.5409 42.0771 17.3174L31.9111 33.5L27.3574 40.749L26.6807 36.8145C26.1034 33.4553 23.1906 31.0002 19.7822 31H7C3.13414 31.0002 6.44234e-08 34.1341 0 38V43.082C0 46.4986 2.467 49.4159 5.83594 49.9844L19.8975 52.3574C19.9487 52.3661 20.0007 52.3704 20.0518 52.3779L10.8652 67H11.2471C9.20735 68.6499 7.90234 71.1722 7.90234 74V159C7.90234 161.761 10.1409 164 12.9023 164H33.5225C36.2839 164 38.5225 161.761 38.5225 159V140C38.5225 144.97 42.552 149 47.5225 149H163.857C168.828 149 172.857 144.971 172.857 140V159C172.857 161.761 175.096 164 177.857 164H198.478C201.239 164 203.478 161.761 203.478 159V74C203.478 71.1721 202.173 68.6499 200.133 67H200.515L190.557 51.6758L205.272 49.7852C208.764 49.3362 211.38 46.3635 211.38 42.8428V38C211.38 34.134 208.246 31 204.38 31H191.18C187.96 31.0001 185.156 33.1966 184.384 36.3223L183.337 40.5664L167.915 16.8379C161.09 6.33633 149.416 0.000106336 136.892 0H73.4072ZM131.151 114C141.092 114 149.151 122.059 149.151 132H62.2285C62.2285 122.059 70.2876 114 80.2285 114H131.151ZM141.713 89C143.093 89.0002 144.213 90.1194 144.213 91.5C144.213 92.8806 143.093 93.9998 141.713 94H124.403L105.69 99L86.9775 94H69.668C68.2873 94 67.168 92.8807 67.168 91.5C67.168 90.1193 68.2873 89 69.668 89H141.713ZM180.248 74.3896C183.654 73.1253 187.394 75.155 188.19 78.7002L189.982 86.6855C190.824 90.4359 187.973 93.9998 184.129 94H163.054C159.74 94 157.054 91.3137 157.054 88V87.1729C157.054 84.6646 158.613 82.4209 160.965 81.5479L180.248 74.3896ZM23.1904 78.7002C23.9866 75.1552 27.7256 73.1255 31.1318 74.3896L50.415 81.5479C52.7665 82.4208 54.3271 84.6645 54.3271 87.1729V88C54.3271 91.3136 51.6407 93.9998 48.3271 94H27.252C23.4082 94 20.5555 90.436 21.3975 86.6855L23.1904 78.7002ZM145.348 15.5C146.908 15.5 148.408 16.1083 149.527 17.1953L162.985 30.2607C163.489 30.7495 163.903 31.3234 164.208 31.9551L172.152 48.3887C174.078 52.3728 171.175 56.9999 166.75 57H43.332C38.9846 57 36.0805 52.5207 37.8545 48.5518L45.1064 32.3262C45.4961 31.4546 46.0888 30.6886 46.834 30.0918L63.4072 16.8174C64.4715 15.9649 65.7946 15.5 67.1582 15.5H145.348Z" fill="white"/>
      <path d="M142.407 0C129.681 8.95115e-05 117.847 6.5409 111.077 17.3174L100.911 33.5L96.3574 40.749L95.6807 36.8145C95.1034 33.4553 92.1906 31.0002 88.7822 31H76C72.1341 31.0002 69 34.1341 69 38V43.082C69 46.4986 71.467 49.4159 74.8359 49.9844L88.8975 52.3574C88.9487 52.3661 89.0007 52.3704 89.0518 52.3779L79.8652 67H80.2471C78.2074 68.6499 76.9023 71.1722 76.9023 74V159C76.9023 161.761 79.1409 164 81.9023 164H102.522C105.284 164 107.522 161.761 107.522 159V140C107.522 144.97 111.552 149 116.522 149H232.857C237.828 149 241.857 144.971 241.857 140V159C241.857 161.761 244.096 164 246.857 164H267.478C270.239 164 272.478 161.761 272.478 159V74C272.478 71.1721 271.173 68.6499 269.133 67H269.515L259.557 51.6758L274.272 49.7852C277.764 49.3362 280.38 46.3635 280.38 42.8428V38C280.38 34.134 277.246 31 273.38 31H260.18C256.96 31.0001 254.156 33.1966 253.384 36.3223L252.337 40.5664L236.915 16.8379C230.09 6.33633 218.416 0.000106336 205.892 0H142.407ZM200.151 114C210.092 114 218.151 122.059 218.151 132H131.229C131.229 122.059 139.288 114 149.229 114H200.151ZM210.713 89C212.093 89.0002 213.213 90.1194 213.213 91.5C213.213 92.8806 212.093 93.9998 210.713 94H193.403L174.69 99L155.978 94H138.668C137.287 94 136.168 92.8807 136.168 91.5C136.168 90.1193 137.287 89 138.668 89H210.713ZM249.248 74.3896C252.654 73.1253 256.394 75.155 257.19 78.7002L258.982 86.6855C259.824 90.4359 256.973 93.9998 253.129 94H232.054C228.74 94 226.054 91.3137 226.054 88V87.1729C226.054 84.6646 227.613 82.4209 229.965 81.5479L249.248 74.3896ZM92.1904 78.7002C92.9866 75.1552 96.7256 73.1255 100.132 74.3896L119.415 81.5479C121.767 82.4208 123.327 84.6645 123.327 87.1729V88C123.327 91.3136 120.641 93.9998 117.327 94H96.252C92.4082 94 89.5555 90.436 90.3975 86.6855L92.1904 78.7002ZM214.348 15.5C215.908 15.5 217.408 16.1083 218.527 17.1953L231.985 30.2607C232.489 30.7495 232.903 31.3234 233.208 31.9551L241.152 48.3887C243.078 52.3728 240.175 56.9999 235.75 57H112.332C107.985 57 105.08 52.5207 106.854 48.5518L114.106 32.3262C114.496 31.4546 115.089 30.6886 115.834 30.0918L132.407 16.8174C133.472 15.9649 134.795 15.5 136.158 15.5H214.348Z" fill="#FED631"/>
    </svg>
  ),
  parking: (
    <svg width="40" height="28" viewBox="0 0 235 166" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M73.4072 0.0909424C60.6806 0.0910319 48.8473 6.63185 42.0771 17.4083L31.9111 33.5909L27.3574 40.84L26.6807 36.9054C26.1034 33.5462 23.1906 31.0911 19.7822 31.0909H7C3.13414 31.0911 6.44234e-08 34.225 0 38.0909V43.173C0 46.5895 2.467 49.5069 5.83594 50.0753L19.8975 52.4484C19.9487 52.457 20.0007 52.4614 20.0518 52.4689L10.8652 67.0909H11.2471C9.20735 68.7409 7.90234 71.2631 7.90234 74.0909V159.091C7.90234 161.852 10.1409 164.091 12.9023 164.091H33.5225C36.2839 164.091 38.5225 161.852 38.5225 159.091V140.091C38.5225 145.061 42.552 149.091 47.5225 149.091H105.69V132.091H62.2285C62.2285 122.15 70.2876 114.091 80.2285 114.091H105.69V99.0909L86.9775 94.0909H69.668C68.2873 94.0909 67.168 92.9716 67.168 91.5909C67.168 90.2102 68.2873 89.091 69.668 89.0909H105.69V57.0909H43.332C38.9846 57.0909 36.0805 52.6117 37.8545 48.6427L45.1064 32.4171C45.4961 31.5455 46.0888 30.7796 46.834 30.1827L63.4072 16.9083C64.4715 16.0559 65.7946 15.5909 67.1582 15.5909H105.69V0.0909424H73.4072ZM23.1904 78.7911C23.9866 75.2461 27.7256 73.2165 31.1318 74.4806L50.415 81.6388C52.7665 82.5118 54.3271 84.7555 54.3271 87.2638V88.0909C54.3271 91.4045 51.6407 94.0908 48.3271 94.0909H27.252C23.4082 94.0909 20.5555 90.527 21.3975 86.7765L23.1904 78.7911Z" fill="#FED631"/>
      <path d="M110.805 165.091C108.044 165.091 105.805 162.852 105.805 160.091V0H174.002C186.362 0 197.03 2.41833 206.004 7.25498C215.033 12.0379 221.992 18.7286 226.883 27.3271C231.773 35.8718 234.218 45.8138 234.218 57.1531C234.218 68.546 231.719 78.5149 226.721 87.0597C221.777 95.5507 214.71 102.134 205.521 106.809C196.331 111.485 185.422 113.822 172.793 113.822H130.714V82.3842H165.377C171.395 82.3842 176.42 81.3363 180.451 79.2404C184.535 77.1445 187.625 74.2157 189.721 70.4538C191.817 66.6383 192.865 62.2047 192.865 57.1531C192.865 52.0477 191.817 47.641 189.721 43.9329C187.625 40.171 184.535 37.2691 180.451 35.2269C176.366 33.1848 171.342 32.1637 165.377 32.1637H145.708V160.091C145.708 162.852 143.469 165.091 140.708 165.091H110.805Z" fill="white"/>
    </svg>
  ),
  lights: (
    <svg width="40" height="33" viewBox="0 0 212 173" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="106" cy="75.5" rx="88" ry="67.5" fill="white"/>
      <path d="M73.4072 0C60.6806 8.95115e-05 48.8473 6.5409 42.0771 17.3174L31.9111 33.5L27.3574 40.749L26.6807 36.8145C26.1034 33.4553 23.1906 31.0002 19.7822 31H7C3.13414 31.0002 6.44234e-08 34.1341 0 38V43.082C0 46.4986 2.467 49.4159 5.83594 49.9844L19.8975 52.3574C19.9487 52.3661 20.0007 52.3704 20.0518 52.3779L10.8652 67H11.2471C9.20735 68.6499 7.90234 71.1722 7.90234 74V159C7.90234 161.761 10.1409 164 12.9023 164H33.5225C36.2839 164 38.5225 161.761 38.5225 159V140C38.5225 144.97 42.552 149 47.5225 149H163.857C168.828 149 172.857 144.971 172.857 140V159C172.857 161.761 175.096 164 177.857 164H198.478C201.239 164 203.478 161.761 203.478 159V74C203.478 71.1721 202.173 68.6499 200.133 67H200.515L190.557 51.6758L205.272 49.7852C208.764 49.3362 211.38 46.3635 211.38 42.8428V38C211.38 34.134 208.246 31 204.38 31H191.18C187.96 31.0001 185.156 33.1966 184.384 36.3223L183.337 40.5664L167.915 16.8379C161.09 6.33633 149.416 0.000106336 136.892 0H73.4072ZM131.151 114C141.092 114 149.151 122.059 149.151 132H62.2285C62.2285 122.059 70.2876 114 80.2285 114H131.151ZM141.713 89C143.093 89.0002 144.213 90.1194 144.213 91.5C144.213 92.8806 143.093 93.9998 141.713 94H124.403L105.69 99L86.9775 94H69.668C68.2873 94 67.168 92.8807 67.168 91.5C67.168 90.1193 68.2873 89 69.668 89H141.713ZM180.248 74.3896C183.654 73.1253 187.394 75.155 188.19 78.7002L189.982 86.6855C190.824 90.4359 187.973 93.9998 184.129 94H163.054C159.74 94 157.054 91.3137 157.054 88V87.1729C157.054 84.6646 158.613 82.4209 160.965 81.5479L180.248 74.3896ZM23.1904 78.7002C23.9866 75.1552 27.7256 73.1255 31.1318 74.3896L50.415 81.5479C52.7665 82.4208 54.3271 84.6645 54.3271 87.1729V88C54.3271 91.3136 51.6407 93.9998 48.3271 94H27.252C23.4082 94 20.5555 90.436 21.3975 86.6855L23.1904 78.7002ZM145.348 15.5C146.908 15.5 148.408 16.1083 149.527 17.1953L162.985 30.2607C163.489 30.7495 163.903 31.3234 164.208 31.9551L172.152 48.3887C174.078 52.3728 171.175 56.9999 166.75 57H43.332C38.9846 57 36.0805 52.5207 37.8545 48.5518L45.1064 32.3262C45.4961 31.4546 46.0888 30.6886 46.834 30.0918L63.4072 16.8174C64.4715 15.9649 65.7946 15.5 67.1582 15.5H145.348Z" fill="#FED631"/>
    </svg>
  ),
  open: (
    <svg width="40" height="36" viewBox="0 0 223 199" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M94.4062 0C98.2722 1.00672e-06 101.406 3.13401 101.406 7V11C101.406 11.1682 101.398 11.3348 101.387 11.5C101.398 11.6652 101.406 11.8318 101.406 12V35H121V12C121 11.8318 121.008 11.6652 121.02 11.5C121.008 11.3348 121 11.1682 121 11V7C121 3.13401 124.134 -1.12614e-07 128 0H167C168.219 5.58522e-07 169.365 0.311532 170.363 0.859375L217.688 17.1904C221.342 18.4515 223.283 22.4363 222.021 26.0908L220.717 29.8721C219.456 33.5264 215.471 35.466 211.816 34.2051L164.853 18H139V35H144.07C156.724 35 168.5 41.4664 175.291 52.1436L190.304 75.748L190.991 71.8008C191.574 68.4479 194.484 66 197.888 66H211C214.866 66 218 69.134 218 73V78.0703C218 81.4921 215.526 84.4121 212.15 84.9746L197.739 87.377C197.727 87.379 197.714 87.3789 197.702 87.3809L207 102H206.655C208.695 103.65 210 106.172 210 109V194C210 196.761 207.761 199 205 199H184C181.239 199 179 196.761 179 194V175C179 179.971 174.971 184 170 184H52C47.0294 184 43 179.971 43 175V194C43 196.761 40.7614 199 38 199H17C14.2386 199 12 196.761 12 194V109C12 106.172 13.305 103.65 15.3447 102H15L25.0811 86.6758L10.1182 84.7773C6.6213 84.3333 4.00016 81.3579 4 77.833V73C4 69.134 7.13401 66 11 66H24.5342C27.7463 66 30.5462 68.1866 31.3252 71.3027L32.3916 75.5654L48.1182 51.6631C54.9616 41.2619 66.5777 35 79.0283 35H83.4062V18H57.5537L10.5898 34.2051C6.93541 35.466 2.95056 33.5264 1.68945 29.8721L0.384765 26.0908C-0.876313 22.4363 1.06424 18.4515 4.71875 17.1904L52.043 0.859375C53.0411 0.311532 54.1873 2.05639e-07 55.4062 0H94.4062ZM85 149C75.0589 149 67 157.059 67 167H155C155 157.059 146.941 149 137 149H85ZM74.5 124C73.1193 124 72 125.119 72 126.5C72 127.881 73.1193 129 74.5 129H92.0557L111 134L129.944 129H147.5C148.881 129 150 127.881 150 126.5C150 125.119 148.881 124 147.5 124H74.5ZM35.4043 109.349C32.0078 108.103 28.29 110.125 27.4883 113.652L25.666 121.67C24.8127 125.424 27.6663 129 31.5166 129H53C56.3137 129 59 126.314 59 123V122.19C58.9999 119.673 57.4287 117.424 55.0654 116.558L35.4043 109.349ZM194.512 113.652C193.71 110.125 189.992 108.103 186.596 109.349L166.935 116.558C164.571 117.424 163 119.673 163 122.19V123C163 126.314 165.686 129 169 129H190.483C194.334 129 197.187 125.424 196.334 121.67L194.512 113.652ZM70.7988 50.5C69.2512 50.5001 67.7635 51.0987 66.6465 52.1699L52.9922 65.2627C52.4839 65.7501 52.0654 66.3235 51.7559 66.9561L43.7275 83.3623C41.7768 87.3485 44.6783 91.9999 49.1162 92H174.199C178.559 91.9999 181.462 87.498 179.665 83.5264L172.335 67.3271C171.94 66.455 171.343 65.6897 170.592 65.0957L153.778 51.7949C152.719 50.9565 151.407 50.5 150.056 50.5H70.7988Z" fill="#FED631"/>
    </svg>
  ),
  tow: (
    <svg width="40" height="45" viewBox="0 0 212 237" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M73.4072 0C60.6806 8.95115e-05 48.8473 6.5409 42.0771 17.3174L31.9111 33.5L27.3574 40.749L26.6807 36.8145C26.1034 33.4553 23.1906 31.0002 19.7822 31H7C3.13414 31.0002 6.44234e-08 34.1341 0 38V43.082C0 46.4986 2.467 49.4159 5.83594 49.9844L19.8975 52.3574C19.9487 52.3661 20.0007 52.3704 20.0518 52.3779L10.8652 67H11.2471C9.20735 68.6499 7.90234 71.1722 7.90234 74V159C7.90234 161.761 10.1409 164 12.9023 164H33.5225C36.2839 164 38.5225 161.761 38.5225 159V140C38.5225 144.97 42.552 149 47.5225 149H163.857C168.828 149 172.857 144.971 172.857 140V159C172.857 161.761 175.096 164 177.857 164H198.478C201.239 164 203.478 161.761 203.478 159V74C203.478 71.1721 202.173 68.6499 200.133 67H200.515L190.557 51.6758L205.272 49.7852C208.764 49.3362 211.38 46.3635 211.38 42.8428V38C211.38 34.134 208.246 31 204.38 31H191.18C187.96 31.0001 185.156 33.1966 184.384 36.3223L183.337 40.5664L167.915 16.8379C161.09 6.33633 149.416 0.000106336 136.892 0H73.4072ZM131.151 114C141.092 114 149.151 122.059 149.151 132H62.2285C62.2285 122.059 70.2876 114 80.2285 114H131.151ZM141.713 89C143.093 89.0002 144.213 90.1194 144.213 91.5C144.213 92.8806 143.093 93.9998 141.713 94H124.403L105.69 99L86.9775 94H69.668C68.2873 94 67.168 92.8807 67.168 91.5C67.168 90.1193 68.2873 89 69.668 89H141.713ZM180.248 74.3896C183.654 73.1253 187.394 75.155 188.19 78.7002L189.982 86.6855C190.824 90.4359 187.973 93.9998 184.129 94H163.054C159.74 94 157.054 91.3137 157.054 88V87.1729C157.054 84.6646 158.613 82.4209 160.965 81.5479L180.248 74.3896ZM23.1904 78.7002C23.9866 75.1552 27.7256 73.1255 31.1318 74.3896L50.415 81.5479C52.7665 82.4208 54.3271 84.6645 54.3271 87.1729V88C54.3271 91.3136 51.6407 93.9998 48.3271 94H27.252C23.4082 94 20.5555 90.436 21.3975 86.6855L23.1904 78.7002ZM145.348 15.5C146.908 15.5 148.408 16.1083 149.527 17.1953L162.985 30.2607C163.489 30.7495 163.903 31.3234 164.208 31.9551L172.152 48.3887C174.078 52.3728 171.175 56.9999 166.75 57H43.332C38.9846 57 36.0805 52.5207 37.8545 48.5518L45.1064 32.3262C45.4961 31.4546 46.0888 30.6886 46.834 30.0918L63.4072 16.8174C64.4715 15.9649 65.7946 15.5 67.1582 15.5H145.348Z" fill="#FED631"/>
      <path d="M201 164C206.523 164 211 168.477 211 174V178C211 183.522 206.523 187.999 201 188H94.5601L203.708 212.673C208.935 213.855 212.214 219.051 211.033 224.278C211.023 224.321 211.011 224.363 211 224.405V227C211 232.522 206.523 236.999 201 237H10.0005C4.47764 237 0.000488281 232.522 0.000488281 227V223C0.00068646 217.477 4.47776 213 10.0005 213H117.128L8.24463 188.385C5.92109 187.86 3.98402 186.541 2.65088 184.779C1.00619 182.997 0.000488281 180.616 0.000488281 178V174C0.000683174 168.477 4.47776 164 10.0005 164H201Z" fill="white"/>
    </svg>
  ),
  alarm: (
    <svg width="40" height="35" viewBox="0 0 208 181" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="106" width="15" height="22" rx="4" fill="white"/>
      <path d="M73.4072 17C60.6806 17.0001 48.8473 23.5409 42.0771 34.3174L31.9111 50.5L27.3574 57.749L26.6807 53.8145C26.1034 50.4553 23.1906 48.0002 19.7822 48H7C3.13414 48.0002 6.44234e-08 51.1341 0 55V60.082C0 63.4986 2.467 66.4159 5.83594 66.9844L19.8975 69.3574C19.9487 69.3661 20.0007 69.3704 20.0518 69.3779L10.8652 84H11.2471C9.20735 85.6499 7.90234 88.1722 7.90234 91V176C7.90234 178.761 10.1409 181 12.9023 181H33.5225C36.2839 181 38.5225 178.761 38.5225 176V157C38.5225 161.97 42.552 166 47.5225 166H105.69V149H62.2285C62.2285 139.059 70.2876 131 80.2285 131H105.69V116L86.9775 111H69.668C68.2873 111 67.168 109.881 67.168 108.5C67.168 107.119 68.2873 106 69.668 106H105.69V74H43.332C38.9846 74 36.0805 69.5207 37.8545 65.5518L45.1064 49.3262C45.4961 48.4546 46.0888 47.6886 46.834 47.0918L63.4072 33.8174C64.4715 32.9649 65.7946 32.5 67.1582 32.5H105.69V17H73.4072ZM23.1904 95.7002C23.9866 92.1552 27.7256 90.1255 31.1318 91.3896L50.415 98.5479C52.7665 99.4208 54.3271 101.665 54.3271 104.173V105C54.3271 108.314 51.6407 111 48.3271 111H27.252C23.4082 111 20.5555 107.436 21.3975 103.686L23.1904 95.7002Z" fill="#FED631"/>
      <path d="M134.07 17C146.724 17 158.5 23.4664 165.291 34.1436L175.694 50.5L180.304 57.748L180.991 53.8008C181.574 50.4479 184.484 48 187.888 48H201C204.866 48 208 51.134 208 55V60.0703C208 63.4921 205.526 66.4121 202.15 66.9746L187.739 69.377C187.727 69.379 187.714 69.3789 187.702 69.3809L197 84H196.655C198.695 85.6499 200 88.1722 200 91V176C200 178.761 197.761 181 195 181H174C171.239 181 169 178.761 169 176V157C169 161.971 164.971 166 160 166H106V149H145C145 139.059 136.941 131 127 131H106V114.68L119.944 111H137.5C138.881 111 140 109.881 140 108.5C140 107.119 138.881 106 137.5 106H106V74H164.199C168.559 73.9999 171.462 69.498 169.665 65.5264L162.335 49.3271C161.94 48.455 161.343 47.6897 160.592 47.0957L143.778 33.7949C142.719 32.9565 141.407 32.5 140.056 32.5H106V17H134.07ZM184.512 95.6523C183.71 92.1247 179.992 90.1033 176.596 91.3486L156.935 98.5576C154.571 99.4241 153 101.673 153 104.19V105C153 108.314 155.686 111 159 111H180.483C184.334 111 187.187 107.424 186.334 103.67L184.512 95.6523Z" fill="white"/>
    </svg>
  ),
  car: (
    <svg width="32" height="28" viewBox="0 0 212 164" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M73.4072 0C60.6806 8.95115e-05 48.8473 6.5409 42.0771 17.3174L31.9111 33.5L27.3574 40.749L26.6807 36.8145C26.1034 33.4553 23.1906 31.0002 19.7822 31H7C3.13414 31.0002 6.44234e-08 34.1341 0 38V43.082C0 46.4986 2.467 49.4159 5.83594 49.9844L19.8975 52.3574C19.9487 52.3661 20.0007 52.3704 20.0518 52.3779L10.8652 67H11.2471C9.20735 68.6499 7.90234 71.1722 7.90234 74V159C7.90234 161.761 10.1409 164 12.9023 164H33.5225C36.2839 164 38.5225 161.761 38.5225 159V140C38.5225 144.97 42.552 149 47.5225 149H163.857C168.828 149 172.857 144.971 172.857 140V159C172.857 161.761 175.096 164 177.857 164H198.478C201.239 164 203.478 161.761 203.478 159V74C203.478 71.1721 202.173 68.6499 200.133 67H200.515L190.557 51.6758L205.272 49.7852C208.764 49.3362 211.38 46.3635 211.38 42.8428V38C211.38 34.134 208.246 31 204.38 31H191.18C187.96 31.0001 185.156 33.1966 184.384 36.3223L183.337 40.5664L167.915 16.8379C161.09 6.33633 149.416 0.000106336 136.892 0H73.4072ZM131.151 114C141.092 114 149.151 122.059 149.151 132H62.2285C62.2285 122.059 70.2876 114 80.2285 114H131.151ZM141.713 89C143.093 89.0002 144.213 90.1194 144.213 91.5C144.213 92.8806 143.093 93.9998 141.713 94H124.403L105.69 99L86.9775 94H69.668C68.2873 94 67.168 92.8807 67.168 91.5C67.168 90.1193 68.2873 89 69.668 89H141.713ZM180.248 74.3896C183.654 73.1253 187.394 75.155 188.19 78.7002L189.982 86.6855C190.824 90.4359 187.973 93.9998 184.129 94H163.054C159.74 94 157.054 91.3137 157.054 88V87.1729C157.054 84.6646 158.613 82.4209 160.965 81.5479L180.248 74.3896ZM23.1904 78.7002C23.9866 75.1552 27.7256 73.1255 31.1318 74.3896L50.415 81.5479C52.7665 82.4208 54.3271 84.6645 54.3271 87.1729V88C54.3271 91.3136 51.6407 93.9998 48.3271 94H27.252C23.4082 94 20.5555 90.436 21.3975 86.6855L23.1904 78.7002ZM145.348 15.5C146.908 15.5 148.408 16.1083 149.527 17.1953L162.985 30.2607C163.489 30.7495 163.903 31.3234 164.208 31.9551L172.152 48.3887C174.078 52.3728 171.175 56.9999 166.75 57H43.332C38.9846 57 36.0805 52.5207 37.8545 48.5518L45.1064 32.3262C45.4961 31.4546 46.0888 30.6886 46.834 30.0918L63.4072 16.8174C64.4715 15.9649 65.7946 15.5 67.1582 15.5H145.348Z" fill="#FED631"/>
    </svg>
  ),
  history: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
      <path d="M12 7V12L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  services: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6.52 6.52 0 0 1-8.65 8.65L5.41 21.59a2.12 2.12 0 1 1-3-3l7.41-7.41A6.52 6.52 0 0 1 18.47 2.53z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  settings: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
      <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  home: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="9,22 9,12 15,12 15,22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  check: (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 24L21 31L34 18" stroke="#0B0F1A" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  arrow: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  back: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 5L7.5 10L12.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
};

// ============================================
// STYLES
// ============================================
const styles = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

:root {
  --bg-primary: ${QAR_COLORS.bgPrimary};
  --bg-card: ${QAR_COLORS.bgCard};
  --bg-card-hover: ${QAR_COLORS.bgCardHover};
  --accent: ${QAR_COLORS.accent};
  --accent-dim: ${QAR_COLORS.accentDim};
  --accent-glow: ${QAR_COLORS.accentGlow};
  --danger: ${QAR_COLORS.danger};
  --warning: ${QAR_COLORS.warning};
  --text-primary: ${QAR_COLORS.textPrimary};
  --text-secondary: ${QAR_COLORS.textSecondary};
  --text-muted: ${QAR_COLORS.textMuted};
  --border: ${QAR_COLORS.border};
  --card-radius: ${QAR_COLORS.cardRadius};
  --btn-radius: ${QAR_COLORS.buttonRadius};
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background: var(--bg-primary);
  color: var(--text-primary);
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
}

.app {
  min-height: 100vh;
  position: relative;
}

/* Grid Pattern Background */
.bg-grid {
  position: fixed;
  inset: 0;
  background-image: 
    linear-gradient(rgba(254, 214, 49, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(254, 214, 49, 0.02) 1px, transparent 1px);
  background-size: 40px 40px;
  pointer-events: none;
  z-index: 0;
}

.container {
  max-width: 480px;
  margin: 0 auto;
  padding: 20px;
  position: relative;
  z-index: 1;
}

/* Header */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  margin-bottom: 24px;
}

.logo {
  font-size: 32px;
  font-weight: 700;
  color: var(--accent);
  letter-spacing: -1px;
}

.logo-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: var(--accent);
  border-radius: 50%;
  margin-left: 2px;
  vertical-align: super;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(0.9); }
}

/* Language Switcher */
.lang-switcher {
  display: flex;
  gap: 4px;
  background: var(--bg-card);
  padding: 4px;
  border-radius: 10px;
  border: 1px solid var(--border);
}

.lang-btn {
  background: transparent;
  border: none;
  color: var(--text-muted);
  font-size: 11px;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 7px;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
}

.lang-btn:hover {
  color: var(--text-secondary);
}

.lang-btn.active {
  background: var(--accent);
  color: var(--bg-primary);
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px 32px;
  border-radius: var(--btn-radius);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  width: 100%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: inherit;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary {
  background: var(--accent);
  color: var(--bg-primary);
}

.btn-primary:hover:not(:disabled) {
  box-shadow: 0 0 30px var(--accent-glow);
  transform: translateY(-2px);
}

.btn-secondary {
  background: var(--bg-card);
  color: var(--text-primary);
  border: 1px solid var(--border);
}

.btn-ghost {
  background: transparent;
  color: var(--text-secondary);
  padding: 12px 20px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
}

.btn-back {
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 20px;
  padding: 8px 0;
  font-family: inherit;
}

/* Action Cards - 2 column grid */
.action-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin: 24px 0;
}

.action-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 32px 20px;
  background: var(--bg-card);
  border: 2px solid transparent;
  border-radius: var(--card-radius);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 140px;
}

.action-card:hover {
  background: var(--bg-card-hover);
  border-color: rgba(254, 214, 49, 0.3);
  box-shadow: 0 8px 32px rgba(254, 214, 49, 0.1);
}

.action-card.selected {
  border-color: var(--accent);
  background: var(--accent-dim);
  box-shadow: 0 0 40px rgba(254, 214, 49, 0.2);
}

.action-card-icon {
  color: var(--accent);
}

.action-card-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  text-align: center;
}

/* Cards */
.card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--card-radius);
  padding: 24px;
  margin-bottom: 16px;
}

/* Car Card */
.car-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--card-radius);
  margin-bottom: 12px;
}

.car-icon {
  width: 56px;
  height: 56px;
  background: var(--accent-dim);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.car-info {
  flex: 1;
}

.car-brand {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 4px;
}

.car-plate {
  font-size: 14px;
  color: var(--text-secondary);
  font-family: 'SF Mono', monospace;
}

/* Status Badges */
.status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.status-active {
  background: var(--accent-dim);
  color: var(--accent);
}

.status-pending {
  background: rgba(255, 184, 77, 0.15);
  color: var(--warning);
}

.status-resolved {
  background: rgba(138, 143, 168, 0.15);
  color: var(--text-secondary);
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

/* Form */
.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 8px;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 16px 20px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--btn-radius);
  color: var(--text-primary);
  font-size: 16px;
  font-family: inherit;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.form-input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-dim);
}

.form-input::placeholder {
  color: var(--text-muted);
}

/* Alert Items */
.alert-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  background: var(--bg-card);
  border-radius: 16px;
  margin-bottom: 10px;
}

.alert-item-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 184, 77, 0.15);
}

.alert-item-content {
  flex: 1;
}

.alert-item-type {
  font-weight: 600;
  margin-bottom: 4px;
}

.alert-item-time {
  font-size: 13px;
  color: var(--text-muted);
}

/* Active Alert Card */
.alert-card-active {
  border: 2px solid var(--danger) !important;
  animation: alertPulse 1.5s infinite;
}

@keyframes alertPulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(255, 77, 106, 0.4); }
  50% { box-shadow: 0 0 20px 5px rgba(255, 77, 106, 0.2); }
}

/* Success Screen */
.success-screen {
  text-align: center;
  padding: 60px 20px;
}

.success-icon {
  width: 100px;
  height: 100px;
  background: var(--accent);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
  box-shadow: 0 0 60px var(--accent-glow);
}

.success-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 12px;
}

.success-text {
  color: var(--text-secondary);
  font-size: 16px;
  margin-bottom: 40px;
}

/* Cooldown */
.cooldown-screen {
  text-align: center;
  padding: 40px 20px;
}

.cooldown-icon {
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.8;
}

.cooldown-timer {
  font-size: 56px;
  font-weight: 700;
  color: var(--accent);
  margin: 24px 0;
  font-family: 'SF Mono', monospace;
  letter-spacing: 2px;
}

.cooldown-text {
  color: var(--text-secondary);
  font-size: 15px;
}

/* Promo Banner */
.promo-banner {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--card-radius);
  padding: 28px;
  margin-top: 32px;
  text-align: center;
}

.promo-banner h3 {
  margin-bottom: 8px;
  font-weight: 600;
}

.promo-banner p {
  color: var(--text-secondary);
  margin-bottom: 20px;
  font-size: 14px;
}

.promo-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--accent);
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  margin-top: 8px;
}

/* Section Title */
.section-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 16px;
}

/* Divider */
.divider {
  height: 1px;
  background: var(--border);
  margin: 30px 0;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 48px 20px;
  color: var(--text-muted);
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.4;
}

/* Loading */
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--border);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Page Content */
.page-content {
  padding-bottom: 100px;
}

/* Fade Animation */
.fade-in {
  animation: fadeIn 0.4s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Live Indicator */
.live-indicator {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--accent);
  margin-bottom: 20px;
  padding: 8px 16px;
  background: var(--accent-dim);
  border-radius: 20px;
  font-weight: 500;
}

.live-dot {
  width: 8px;
  height: 8px;
  background: var(--accent);
  border-radius: 50%;
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

/* Push Banner */
.push-banner {
  background: var(--warning);
  color: var(--bg-primary);
  padding: 14px 16px;
  border-radius: var(--btn-radius);
  margin-bottom: 20px;
  text-align: center;
  cursor: pointer;
  font-weight: 600;
}

/* Bottom Navigation */
.nav-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(11, 15, 26, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid var(--border);
  padding: 8px 0;
  padding-bottom: calc(8px + env(safe-area-inset-bottom));
  z-index: 100;
}

.nav-items {
  display: flex;
  justify-content: space-around;
  max-width: 480px;
  margin: 0 auto;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 16px;
  color: var(--text-muted);
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.3s;
}

.nav-item.active {
  color: var(--accent);
}

.nav-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-label {
  font-size: 10px;
  font-weight: 600;
  font-family: inherit;
}

/* Service Cards */
.service-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--card-radius);
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.service-card:hover {
  border-color: rgba(254, 214, 49, 0.3);
  background: var(--bg-card-hover);
}

.service-icon {
  width: 56px;
  height: 56px;
  background: var(--accent-dim);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

.service-info {
  flex: 1;
}

.service-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}

.service-desc {
  font-size: 13px;
  color: var(--text-secondary);
}

.service-arrow {
  color: var(--text-muted);
}

/* Partner Card */
.partner-card {
  background: linear-gradient(135deg, rgba(254, 214, 49, 0.1) 0%, var(--bg-card) 100%);
  border: 2px solid var(--accent);
  border-radius: var(--card-radius);
  padding: 20px;
  margin-bottom: 16px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
}

.partner-card:hover {
  box-shadow: 0 0 30px var(--accent-glow);
}

.partner-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: var(--accent);
  color: var(--bg-primary);
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

/* Place Card */
.place-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.place-card:hover {
  border-color: rgba(254, 214, 49, 0.3);
}

.place-icon {
  width: 48px;
  height: 48px;
  background: var(--accent-dim);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.place-info {
  flex: 1;
}

.place-name {
  font-weight: 600;
  margin-bottom: 4px;
}

.place-distance {
  font-size: 13px;
  color: var(--text-secondary);
}

/* Settings */
.settings-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: all 0.3s;
}

.settings-item:hover {
  background: var(--bg-card-hover);
}

.settings-label {
  font-weight: 500;
}

.settings-value {
  color: var(--text-secondary);
  font-size: 14px;
}

/* Toggle Switch */
.toggle {
  width: 52px;
  height: 30px;
  border-radius: 15px;
  position: relative;
  transition: background 0.3s;
  flex-shrink: 0;
}

.toggle-on {
  background: var(--accent);
}

.toggle-off {
  background: var(--border);
}

.toggle-knob {
  width: 26px;
  height: 26px;
  border-radius: 13px;
  background: #fff;
  position: absolute;
  top: 2px;
  transition: left 0.3s;
}

/* Footer promo text */
.footer-promo {
  text-align: center;
  padding: 32px 20px;
  color: var(--text-secondary);
  font-size: 14px;
}

.footer-promo strong {
  color: var(--text-primary);
  font-weight: 600;
}

.footer-promo a {
  color: var(--accent);
  text-decoration: none;
  font-weight: 500;
}
`;

// ============================================
// ALERT TYPES
// ============================================
const ALERT_TYPES = {
  blocking: { icon: 'blocked', labelKey: 'blocking' },
  parking: { icon: 'parking', labelKey: 'parking' },
  lights_on: { icon: 'lights', labelKey: 'lights_on' },
  open: { icon: 'open', labelKey: 'open' },
  alarm: { icon: 'alarm', labelKey: 'alarm' },
  tow: { icon: 'tow', labelKey: 'tow' }
};

// ============================================
// SERVICE CATEGORIES
// ============================================
const SERVICE_CATEGORIES = [
  { id: 'parking', icon: '🅿️', name: 'Парковки', desc: 'Ближайшие парковки', type: 'parking' },
  { id: 'sto', icon: '🔧', name: 'СТО', desc: 'Автосервисы и ремонт', type: 'car_repair' },
  { id: 'wash', icon: '🚿', name: 'Мойки', desc: 'Автомойки', type: 'car_wash' },
  { id: 'tire', icon: '🛞', name: 'Шиномонтаж', desc: 'Шины и диски', type: 'tire_shop' },
  { id: 'tow', icon: '🚛', name: 'Эвакуаторы', desc: 'Вызов эвакуатора', type: 'tow' }
];

const PARTNERS = {
  parking: { id: 'partner-parking', name: 'Premium Parking Center', discount: '20% скидка для QAR', price: 'от 30 лей/час', extra: '45 мест', lat: 47.0245, lng: 28.8322 },
  sto: { id: 'partner-sto', name: 'AutoPro Service', discount: '15% скидка для QAR', price: 'Диагностика бесплатно', extra: 'Работаем 24/7', lat: 47.0255, lng: 28.8355 },
  wash: { id: 'partner-wash', name: 'Crystal Car Wash', discount: '25% скидка для QAR', price: 'от 80 лей', extra: 'Экспресс за 15 мин', lat: 47.0230, lng: 28.8300 },
  tire: { id: 'partner-tire', name: 'TireMax', discount: '10% скидка для QAR', price: 'от 150 лей', extra: 'Хранение шин', lat: 47.0260, lng: 28.8280 },
  tow: { id: 'partner-tow', name: 'Fast Tow 24/7', discount: 'Фикс. цена для QAR', price: 'от 300 лей', extra: 'Приезд за 20 мин', lat: 47.0240, lng: 28.8340 }
};

// ============================================
// UTILITIES
// ============================================
const formatDate = (t) => {
  if (!t) return 'Только что';
  try {
    const d = t.toDate ? t.toDate() : new Date(t);
    const diff = Date.now() - d;
    if (diff < 60000) return 'Только что';
    if (diff < 3600000) return `${Math.floor(diff/60000)} мин назад`;
    if (diff < 86400000) return `${Math.floor(diff/3600000)} ч назад`;
    return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  } catch { return 'Только что'; }
};

const playNotificationSound = () => {
  if (navigator.vibrate) navigator.vibrate([300, 100, 300, 100, 300]);
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [0, 0.2, 0.4].forEach((d, i) => {
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.connect(g); g.connect(ctx.destination);
      o.frequency.value = i === 1 ? 1000 : 800;
      o.type = 'square'; g.gain.value = 0.3;
      o.start(ctx.currentTime + d); o.stop(ctx.currentTime + d + 0.15);
    });
  } catch {}
};

const RATE_LIMIT_KEY = 'qar_last_';
const checkRateLimit = (carId) => {
  const last = localStorage.getItem(RATE_LIMIT_KEY + carId);
  if (!last) return { allowed: true, remaining: 0 };
  const diff = Date.now() - parseInt(last);
  const limit = 5 * 60 * 1000;
  return diff >= limit ? { allowed: true, remaining: 0 } : { allowed: false, remaining: Math.ceil((limit - diff) / 1000) };
};
const setRateLimit = (carId) => localStorage.setItem(RATE_LIMIT_KEY + carId, Date.now().toString());

const setupFCM = async (userId) => {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;
    const reg = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    messaging = getMessaging(app);
    const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: reg });
    if (token) {
      await updateDoc(doc(db, 'users', userId), { fcm_token: token, fcm_updated_at: serverTimestamp() });
      return token;
    }
    return null;
  } catch (e) {
    console.error('FCM error:', e);
    return null;
  }
};

// ============================================
// COMPONENTS
// ============================================
const LanguageSwitcher = ({ lang, setLang }) => (
  <div className="lang-switcher">
    {['ru', 'en', 'ro'].map(l => (
      <button 
        key={l} 
        className={`lang-btn ${lang === l ? 'active' : ''}`}
        onClick={() => { setLang(l); setStoredLanguage(l); }}
      >
        {l.toUpperCase()}
      </button>
    ))}
  </div>
);

const Header = ({ user, onLogout, lang, setLang, t }) => (
  <header className="header">
    <div className="logo">QAR<span className="logo-dot"></span></div>
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <LanguageSwitcher lang={lang} setLang={setLang} />
      {user && <button className="btn-ghost" onClick={onLogout}>{t.logout}</button>}
    </div>
  </header>
);

const Loading = () => (
  <div className="loading">
    <div className="spinner"></div>
  </div>
);

const StatusBadge = ({ status }) => (
  <span className={`status status-${status}`}>
    <span className="status-dot"></span>
    {status === 'active' ? 'Активен' : status === 'pending' ? 'Ожидание' : 'Решено'}
  </span>
);

const BottomNav = ({ active, onChange }) => (
  <nav className="nav-bottom">
    <div className="nav-items">
      {[
        { id: 'home', icon: Icons.home, label: 'Авто' },
        { id: 'history', icon: Icons.history, label: 'История' },
        { id: 'services', icon: Icons.services, label: 'Сервисы' },
        { id: 'settings', icon: Icons.settings, label: 'Настройки' }
      ].map(item => (
        <button
          key={item.id}
          className={`nav-item ${active === item.id ? 'active' : ''}`}
          onClick={() => onChange(item.id)}
        >
          <span className="nav-icon">{item.icon}</span>
          <span className="nav-label">{item.label}</span>
        </button>
      ))}
    </div>
  </nav>
);

// Action Card Component
const ActionCard = ({ icon, label, selected, onClick, disabled }) => (
  <button
    className={`action-card ${selected ? 'selected' : ''}`}
    onClick={onClick}
    disabled={disabled}
  >
    <div className="action-card-icon">{icon}</div>
    <span className="action-card-label">{label}</span>
  </button>
);

// ============================================
// PUBLIC ALERT PAGE (Main QR scan page)
// ============================================
const PublicAlertPage = ({ carData, t }) => {
  const [selectedType, setSelectedType] = useState(null);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (carData?.car_id) {
      const { allowed, remaining } = checkRateLimit(carData.car_id);
      if (!allowed) setCooldown(remaining);
    }
  }, [carData]);

  useEffect(() => {
    if (cooldown > 0) {
      const t = setInterval(() => setCooldown(p => p <= 1 ? 0 : p - 1), 1000);
      return () => clearInterval(t);
    }
  }, [cooldown]);

  const handleSend = async () => {
    if (!selectedType || !carData?.car_id) return;
    const { allowed, remaining } = checkRateLimit(carData.car_id);
    if (!allowed) {
      setCooldown(remaining);
      return;
    }
    setSending(true);
    playNotificationSound();
    try {
      await addDoc(collection(db, 'alerts'), {
        car_id: carData.car_id,
        type: selectedType,
        status: 'pending',
        created_at: serverTimestamp()
      });
      setRateLimit(carData.car_id);
      setSent(true);
    } catch (e) {
      console.error(e);
    }
    setSending(false);
  };

  // Cooldown Screen
  if (cooldown > 0) {
    return (
      <div className="fade-in cooldown-screen">
        <div className="cooldown-icon">⏳</div>
        <h2 style={{ marginBottom: 8 }}>{t.wait}</h2>
        <div className="cooldown-timer">
          {Math.floor(cooldown / 60)}:{(cooldown % 60).toString().padStart(2, '0')}
        </div>
        <p className="cooldown-text">{t.beforeNextMessage}</p>
      </div>
    );
  }

  // Success Screen
  if (sent) {
    return (
      <div className="success-screen fade-in">
        <div className="success-icon">{Icons.check}</div>
        <h1 className="success-title">{t.messageSent}</h1>
        <p className="success-text">{t.ownerNotified}</p>
      </div>
    );
  }

  // Main Alert Selection
  return (
    <div className="fade-in">
      {/* Car Info Header */}
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <h2 style={{ fontSize: 24, fontWeight: 600, marginBottom: 6 }}>
          {carData?.brand || 'Auto'}
        </h2>
        <p style={{ color: 'var(--text-secondary)', fontSize: 15 }}>
          {t.selectProblem}
        </p>
      </div>

      {/* Action Grid 2x3 */}
      <div className="action-grid">
        {Object.entries(ALERT_TYPES).map(([type, data]) => (
          <ActionCard
            key={type}
            icon={Icons[data.icon]}
            label={t[type] || data.label}
            selected={selectedType === type}
            onClick={() => setSelectedType(type)}
            disabled={sending}
          />
        ))}
      </div>

      {/* Send Button */}
      <button
        className="btn btn-primary"
        onClick={handleSend}
        disabled={!selectedType || sending}
        style={{ marginTop: 24 }}
      >
        {sending ? t.sending : t.send}
      </button>
    </div>
  );
};

// ============================================
// LOGIN PAGE
// ============================================
const LoginPage = ({ onSuccess, t }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      onSuccess?.();
    } catch {
      setError(t.error);
    }
    setLoading(false);
  };

  return (
    <div className="fade-in">
      <div style={{ textAlign: 'center', marginBottom: 32 }}>
        <h2 style={{ fontSize: 26, fontWeight: 700, marginBottom: 8 }}>{t.login}</h2>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">{t.email}</label>
          <input
            type="email"
            className="form-input"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="your@email.com"
          />
        </div>
        <div className="form-group">
          <label className="form-label">{t.password}</label>
          <input
            type="password"
            className="form-input"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        </div>
        {error && <p style={{ color: 'var(--danger)', textAlign: 'center', marginBottom: 20 }}>{error}</p>}
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? '...' : t.enter}
        </button>
      </form>
      <div className="divider"></div>
      <p style={{ textAlign: 'center', color: 'var(--text-secondary)', fontSize: 14 }}>
        {t.noAccount} <a href="/landing.html" style={{ color: 'var(--accent)' }}>{t.orderSticker}</a>
      </p>
    </div>
  );
};

// ============================================
// REGISTRATION PAGE
// ============================================
const RegistrationPage = ({ uuid, onComplete, t }) => {
  const [brand, setBrand] = useState('');
  const [model, setModel] = useState('');
  const [plate, setPlate] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!brand || !plate || !phone) return;
    setLoading(true);
    try {
      // Create user if not exists
      let userId = auth.currentUser?.uid;
      if (!userId) {
        // For now, create anonymous user
        const userRef = await addDoc(collection(db, 'users'), {
          phone,
          created_at: serverTimestamp()
        });
        userId = userRef.id;
      }
      
      // Create car
      const carRef = await addDoc(collection(db, 'cars'), {
        brand,
        model,
        plate,
        user_id: userId,
        created_at: serverTimestamp()
      });
      
      // Update QR code
      await updateDoc(doc(db, 'qr_codes', uuid), {
        status: 'active',
        car_id: carRef.id,
        activated_at: serverTimestamp()
      });
      
      onComplete?.();
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  return (
    <div className="fade-in">
      <div style={{ textAlign: 'center', marginBottom: 32 }}>
        <h2 style={{ fontSize: 26, fontWeight: 700, marginBottom: 8 }}>{t.activation}</h2>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">{t.carBrand}</label>
          <input
            type="text"
            className="form-input"
            value={brand}
            onChange={e => setBrand(e.target.value)}
            placeholder="Toyota, BMW..."
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">{t.carModel}</label>
          <input
            type="text"
            className="form-input"
            value={model}
            onChange={e => setModel(e.target.value)}
            placeholder="Camry, X5..."
          />
        </div>
        <div className="form-group">
          <label className="form-label">{t.carPlate}</label>
          <input
            type="text"
            className="form-input"
            value={plate}
            onChange={e => setPlate(e.target.value.toUpperCase())}
            placeholder="ABC 123"
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">{t.phone}</label>
          <input
            type="tel"
            className="form-input"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            placeholder="+373..."
            required
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? '...' : t.activateQR}
        </button>
      </form>
    </div>
  );
};

// ============================================
// HOME TAB
// ============================================
const HomeTab = ({ cars, alerts, onResolve, t }) => {
  const pending = alerts.filter(a => a.status === 'pending');

  return (
    <div className="fade-in">
      {pending.length > 0 && (
        <div style={{ marginBottom: 30 }}>
          <h3 className="section-title">🔴 {t.active} ({pending.length})</h3>
          {pending.map(alert => (
            <div key={alert.id} className="card alert-card-active">
              <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 16 }}>
                <div style={{ color: 'var(--accent)' }}>
                  {Icons[ALERT_TYPES[alert.type]?.icon] || Icons.alarm}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 18 }}>{t[alert.type] || ALERT_TYPES[alert.type]?.label}</div>
                  <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>{formatDate(alert.created_at)}</div>
                </div>
              </div>
              <button className="btn btn-primary" onClick={() => onResolve(alert.id)}>
                ✓ Проблема устранена
              </button>
            </div>
          ))}
        </div>
      )}

      <h3 className="section-title">🚗 Мои автомобили</h3>
      {cars.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🚗</div>
          <p>Нет автомобилей</p>
        </div>
      ) : (
        cars.map(car => (
          <div key={car.id} className="car-card">
            <div className="car-icon">{Icons.car}</div>
            <div className="car-info">
              <div className="car-brand">{car.brand}</div>
              <div className="car-plate">{car.plate_number}</div>
            </div>
            <StatusBadge status="active" />
          </div>
        ))
      )}
    </div>
  );
};

// ============================================
// HISTORY TAB
// ============================================
const HistoryTab = ({ alerts }) => (
  <div className="fade-in">
    <h3 className="section-title">📋 История уведомлений</h3>
    {alerts.length === 0 ? (
      <div className="empty-state">
        <div className="empty-icon">📭</div>
        <p>Пока нет уведомлений</p>
      </div>
    ) : (
      alerts.map(alert => (
        <div key={alert.id} className="alert-item" style={{ opacity: alert.status === 'resolved' ? 0.6 : 1 }}>
          <div className="alert-item-icon" style={{ color: 'var(--accent)' }}>
            {Icons[ALERT_TYPES[alert.type]?.icon] || Icons.alarm}
          </div>
          <div className="alert-item-content">
            <div className="alert-item-type">{ALERT_TYPES[alert.type]?.label}</div>
            <div className="alert-item-time">{formatDate(alert.created_at)}</div>
          </div>
          <StatusBadge status={alert.status} />
        </div>
      ))
    )}
  </div>
);

// ============================================
// SERVICE CATEGORY VIEW
// ============================================
const ServiceCategoryView = ({ category, onBack }) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const [places, setPlaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const partner = PARTNERS[category.id];

  useEffect(() => {
    let isMounted = true;
    mapInstanceRef.current = null;

    const loadGoogleMaps = () => {
      if (window.google?.maps) { initMap(); return; }
      const existing = document.querySelector('script[src*="maps.googleapis.com"]');
      if (existing) { existing.addEventListener('load', () => isMounted && initMap()); return; }
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places,geometry`;
      script.async = true;
      script.defer = true;
      script.onload = () => isMounted && initMap();
      document.head.appendChild(script);
    };

    const initMap = () => {
      if (!isMounted || !mapRef.current || mapInstanceRef.current) return;
      navigator.geolocation.getCurrentPosition(
        (pos) => isMounted && createMap({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
        () => isMounted && createMap({ lat: 47.0245, lng: 28.8322 })
      );
    };

    const createMap = (location) => {
      if (!mapRef.current || mapInstanceRef.current) return;
      const map = new window.google.maps.Map(mapRef.current, {
        center: location, zoom: 14,
        styles: [
          { elementType: 'geometry', stylers: [{ color: '#0B0F1A' }] },
          { elementType: 'labels.text.fill', stylers: [{ color: '#8A8FA8' }] },
          { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#151A27' }] },
          { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#0B0F1A' }] }
        ],
        disableDefaultUI: true, zoomControl: true
      });
      mapInstanceRef.current = map;

      new window.google.maps.Marker({
        position: location, map,
        icon: { path: window.google.maps.SymbolPath.CIRCLE, scale: 10, fillColor: '#FED631', fillOpacity: 1, strokeColor: '#fff', strokeWeight: 2 }
      });

      if (category.id === 'tow') {
        setPlaces([]);
        setLoading(false);
        return;
      }

      const service = new window.google.maps.places.PlacesService(map);
      const searchType = category.type === 'tire_shop' ? 'car_repair' : category.type;

      service.nearbySearch({ location, radius: 3000, type: searchType }, (results, status) => {
        if (!isMounted) return;
        if (status === window.google.maps.places.PlacesServiceStatus.OK && results) {
          let filtered = results;
          if (category.id === 'tire') {
            filtered = results.filter(p => p.name.toLowerCase().includes('шин') || p.name.toLowerCase().includes('tire') || p.name.toLowerCase().includes('колес'));
          }
          const data = filtered.slice(0, 8).map((place) => {
            new window.google.maps.Marker({ position: place.geometry.location, map, label: { text: category.icon, fontSize: '16px' } });
            const dist = window.google.maps.geometry.spherical.computeDistanceBetween(new window.google.maps.LatLng(location.lat, location.lng), place.geometry.location);
            return { id: place.place_id, name: place.name, distance: Math.round(dist), lat: place.geometry.location.lat(), lng: place.geometry.location.lng(), rating: place.rating };
          });
          setPlaces(data.sort((a, b) => a.distance - b.distance));
        }
        setLoading(false);
      });
    };

    loadGoogleMaps();
    return () => { isMounted = false; };
  }, [category]);

  const openNavigation = (p) => window.open(`https://www.google.com/maps/dir/?api=1&destination=${p.lat},${p.lng}&travelmode=driving`, '_blank');
  const callPhone = (phone) => window.open(`tel:${phone}`, '_self');

  return (
    <div className="fade-in">
      <button className="btn-back" onClick={onBack}>
        {Icons.back} Назад к сервисам
      </button>
      <h3 className="section-title">{category.icon} {category.name}</h3>

      <div ref={mapRef} style={{ width: '100%', height: 180, borderRadius: 'var(--card-radius)', marginBottom: 20, background: 'var(--bg-card)' }} />

      {partner && (
        <div className="partner-card" onClick={() => category.id === 'tow' ? callPhone('+37360123456') : openNavigation(partner)}>
          <div className="partner-badge">ПАРТНЁР</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <div style={{ width: 56, height: 56, background: 'var(--accent)', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28 }}>{category.icon}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 4 }}>{partner.name}</div>
              <div style={{ color: 'var(--accent)', fontSize: 13, fontWeight: 600, marginBottom: 2 }}>{partner.discount}</div>
              <div style={{ display: 'flex', gap: 12, fontSize: 12, color: 'var(--text-secondary)' }}>
                <span>{partner.price}</span><span>•</span><span>{partner.extra}</span>
              </div>
            </div>
            <div style={{ color: 'var(--accent)' }}>{Icons.arrow}</div>
          </div>
        </div>
      )}

      {category.id === 'tow' ? (
        <div style={{ textAlign: 'center', padding: 20, color: 'var(--text-secondary)' }}>
          <p>Нажмите на партнёра для вызова эвакуатора</p>
        </div>
      ) : loading ? <Loading /> : places.length === 0 ? (
        <div className="empty-state"><div className="empty-icon">{category.icon}</div><p>Ничего не найдено поблизости</p></div>
      ) : (
        places.map(p => (
          <div key={p.id} className="place-card" onClick={() => openNavigation(p)}>
            <div className="place-icon">{category.icon}</div>
            <div className="place-info">
              <div className="place-name">{p.name}</div>
              <div className="place-distance">📍 {p.distance < 1000 ? `${p.distance} м` : `${(p.distance / 1000).toFixed(1)} км`}{p.rating ? ` • ⭐ ${p.rating}` : ''}</div>
            </div>
            <div style={{ color: 'var(--accent)' }}>{Icons.arrow}</div>
          </div>
        ))
      )}
    </div>
  );
};

// ============================================
// SERVICES TAB
// ============================================
const ServicesTab = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  if (selectedCategory) {
    return <ServiceCategoryView category={selectedCategory} onBack={() => setSelectedCategory(null)} />;
  }

  return (
    <div className="fade-in">
      <h3 className="section-title">🛠 Сервисы</h3>
      <p style={{ color: 'var(--text-secondary)', marginBottom: 20, fontSize: 14 }}>Партнёры со скидками для пользователей QAR</p>
      {SERVICE_CATEGORIES.map(cat => (
        <div key={cat.id} className="service-card" onClick={() => setSelectedCategory(cat)}>
          <div className="service-icon">{cat.icon}</div>
          <div className="service-info">
            <div className="service-name">{cat.name}</div>
            <div className="service-desc">{cat.desc}</div>
          </div>
          <div className="service-arrow">{Icons.arrow}</div>
        </div>
      ))}
    </div>
  );
};

// ============================================
// SETTINGS TAB
// ============================================
const SettingsTab = ({ user, pushEnabled, onEnablePush }) => {
  const [isOn, setIsOn] = useState(pushEnabled);
  const [loading, setLoading] = useState(false);

  useEffect(() => { setIsOn(pushEnabled); }, [pushEnabled]);

  const handleToggle = async () => {
    if (loading) return;
    setLoading(true);
    if (isOn) {
      try {
        await updateDoc(doc(db, 'users', user.uid), { fcm_token: null });
        setIsOn(false);
      } catch (e) { console.error(e); }
    } else {
      try {
        await onEnablePush();
        setIsOn(true);
      } catch (e) { console.error(e); }
    }
    setLoading(false);
  };

  return (
    <div className="fade-in">
      <h3 className="section-title">⚙️ Настройки</h3>
      
      <div className="settings-item" onClick={handleToggle}>
        <div>
          <div className="settings-label">Push-уведомления</div>
          <div className="settings-value">{loading ? 'Подождите...' : isOn ? 'Включены' : 'Выключены'}</div>
        </div>
        <div className={`toggle ${isOn ? 'toggle-on' : 'toggle-off'}`} style={{ opacity: loading ? 0.5 : 1 }}>
          <div className="toggle-knob" style={{ left: isOn ? 24 : 2 }} />
        </div>
      </div>

      <div className="settings-item" style={{ cursor: 'default' }}>
        <div>
          <div className="settings-label">Email</div>
          <div className="settings-value">{user?.email || '—'}</div>
        </div>
      </div>

      <div className="settings-item" style={{ cursor: 'default' }}>
        <div>
          <div className="settings-label">Версия</div>
          <div className="settings-value">2.0.0</div>
        </div>
      </div>

      <div style={{ marginTop: 30 }}>
        <button className="btn btn-secondary" style={{ background: 'rgba(255,77,106,0.1)', borderColor: 'rgba(255,77,106,0.3)', color: 'var(--danger)' }}>
          Удалить аккаунт
        </button>
      </div>
    </div>
  );
};

// ============================================
// DASHBOARD PAGE
// ============================================
const DashboardPage = ({ user, t, lang, setLang }) => {
  const [cars, setCars] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('home');
  const [pushEnabled, setPushEnabled] = useState(false);
  const [showPushBanner, setShowPushBanner] = useState(false);
  const alertCountRef = useRef(0);
  const unsubRef = useRef(null);

  useEffect(() => {
    if ('Notification' in window) {
      if (Notification.permission === 'granted') setPushEnabled(true);
      else if (Notification.permission === 'default') setShowPushBanner(true);
    }
  }, []);

  const enablePush = async () => {
    const token = await setupFCM(user.uid);
    if (token) {
      setPushEnabled(true);
      setShowPushBanner(false);
    }
  };

  useEffect(() => {
    const load = async () => {
      try {
        const carsQ = query(collection(db, 'cars'), where('owner_id', '==', user.uid));
        const carsSnap = await getDocs(carsQ);
        const carsData = carsSnap.docs.map(d => ({ id: d.id, ...d.data() }));
        setCars(carsData);

        if (carsData.length > 0) {
          const carIds = carsData.map(c => c.id);
          const alertsQ = query(collection(db, 'alerts'), where('car_id', 'in', carIds), orderBy('created_at', 'desc'));
          unsubRef.current = onSnapshot(alertsQ, (snap) => {
            const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
            const pending = data.filter(a => a.status === 'pending').length;
            if (pending > alertCountRef.current && alertCountRef.current >= 0) playNotificationSound();
            alertCountRef.current = pending;
            setAlerts(data);
            setLoading(false);
          });
          if (Notification.permission === 'granted') {
            await setupFCM(user.uid);
            if (messaging) onMessage(messaging, () => playNotificationSound());
          }
        } else {
          setLoading(false);
        }
      } catch (e) {
        console.error(e);
        setLoading(false);
      }
    };
    load();
    return () => unsubRef.current?.();
  }, [user.uid]);

  const handleResolve = async (id) => {
    try {
      await updateDoc(doc(db, 'alerts', id), { status: 'resolved', resolved_at: serverTimestamp() });
    } catch (e) { console.error(e); }
  };

  if (loading) return <Loading />;

  return (
    <div className="page-content">
      {showPushBanner && (
        <div className="push-banner" onClick={enablePush}>
          🔔 {t.pushNotifications}
        </div>
      )}
      <div className="live-indicator">
        <span className="live-dot"></span>
        {pushEnabled ? t.pushNotifications : t.active}
      </div>
      
      {activeTab === 'home' && <HomeTab cars={cars} alerts={alerts} onResolve={handleResolve} t={t} />}
      {activeTab === 'history' && <HistoryTab alerts={alerts} t={t} />}
      {activeTab === 'services' && <ServicesTab t={t} />}
      {activeTab === 'settings' && <SettingsTab user={user} pushEnabled={pushEnabled} onEnablePush={enablePush} t={t} lang={lang} setLang={setLang} />}
      
      <BottomNav active={activeTab} onChange={setActiveTab} t={t} />
    </div>
  );
};

// ============================================
// MAIN APP
// ============================================
export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState('loading');
  const [qrData, setQrData] = useState(null);
  const [carData, setCarData] = useState(null);
  const [lang, setLang] = useState(getStoredLanguage());
  
  const t = TRANSLATIONS[lang];
  
  const handleSetLang = (newLang) => {
    setLang(newLang);
    setStoredLanguage(newLang);
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = styles;
    document.head.appendChild(style);

    const unsub = onAuthStateChanged(auth, u => {
      setUser(u);
      setLoading(false);
    });

    const path = window.location.pathname;
    const match = path.match(/\/q\/([a-zA-Z0-9-]+)/);
    if (match) checkQR(match[1]);

    return () => unsub();
  }, []);

  useEffect(() => {
    if (!loading && currentPage === 'loading' && !window.location.pathname.includes('/q/')) {
      setCurrentPage(user ? 'dashboard' : 'login');
    }
  }, [loading, user, currentPage]);

  const checkQR = async (uuid) => {
    try {
      const qrDoc = await getDoc(doc(db, 'qr_codes', uuid));
      if (!qrDoc.exists()) {
        alert('QR не найден');
        setCurrentPage('login');
        return;
      }
      const info = qrDoc.data();
      setQrData({ uuid, ...info });
      if (info.status === 'inactive') setCurrentPage('register');
      else if (info.status === 'active' && info.car_id) {
        const carDoc = await getDoc(doc(db, 'cars', info.car_id));
        if (carDoc.exists()) setCarData({ car_id: info.car_id, ...carDoc.data() });
        setCurrentPage('public_alert');
      } else setCurrentPage('login');
    } catch {
      setCurrentPage('login');
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    setCurrentPage('login');
  };

  if (loading) {
    return (
      <div className="app">
        <div className="bg-grid"></div>
        <div className="container">
          <Header lang={lang} setLang={handleSetLang} t={t} />
          <Loading />
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="bg-grid"></div>
      <div className="container">
        <Header user={user} onLogout={handleLogout} lang={lang} setLang={handleSetLang} t={t} />
        {currentPage === 'login' && <LoginPage onSuccess={() => setCurrentPage('dashboard')} t={t} />}
        {currentPage === 'register' && <RegistrationPage uuid={qrData?.uuid} onComplete={() => setCurrentPage('dashboard')} t={t} />}
        {currentPage === 'public_alert' && <PublicAlertPage carData={carData} t={t} />}
        {currentPage === 'dashboard' && user && <DashboardPage user={user} t={t} lang={lang} setLang={handleSetLang} />}
      </div>
    </div>
  );
}
